import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loyaltyPoints: {},
};

export const loyaltyPointsSlice = createSlice({
  name: "loyaltyPointsSlice",
  initialState,
  reducers: {
    updateLoyaltyPoints(state, action) {
      state.loyaltyPoints = action.payload.loyaltyPoints;
    },
    resetLoyaltyState: (state) => initialState,
  },
});
export const loyaltyPointsActions = loyaltyPointsSlice.actions;
export default loyaltyPointsSlice.reducer;
